import { c as _c } from "react/compiler-runtime";
import { SheetPropertiesType } from "@website/ui/sheet/sheet.types";
import { MouseEvent, useEffect, useEffectEvent, useRef, useState } from "react";
export const useSheet = properties => {
  const $ = _c(15);
  const rootReference = useRef(null);
  const {
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby,
    id,
    animate,
    open,
    onClose
  } = properties;
  const [animateState, setAnimateState] = useState("exited");
  let t0;
  if ($[0] !== onClose) {
    t0 = () => {
      onClose();
    };
    $[0] = onClose;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCloseEvent = useEffectEvent(t0);
  let t1;
  if ($[2] !== animate || $[3] !== onCloseEvent || $[4] !== open) {
    t1 = () => {
      if (open) {
        const checkIfClickedOutside = t2 => {
          const {
            target
          } = t2;
          if (open && rootReference.current && !rootReference.current.contains(target as Node)) {
            onCloseEvent();
          }
        };
        const duration = animate === "normal" ? 0 : 150;
        document.addEventListener("click", checkIfClickedOutside);
        setAnimateState("initial");
        setTimeout(() => {
          setAnimateState("entering");
          setTimeout(() => {
            setAnimateState("entered");
          }, duration);
        }, 20);
        return () => {
          document.removeEventListener("click", checkIfClickedOutside);
          setAnimateState("exiting");
          setTimeout(() => {
            setAnimateState("exited");
          }, duration);
        };
      }
    };
    $[2] = animate;
    $[3] = onCloseEvent;
    $[4] = open;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== open) {
    t2 = [open];
    $[6] = open;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  const stopPropagationOnModal = _temp;
  let t3;
  if ($[8] !== ariaDescribedby || $[9] !== ariaLabelledby || $[10] !== id) {
    t3 = {
      "aria-labelledby": ariaLabelledby,
      "aria-describedby": ariaDescribedby,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      ref: rootReference,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[8] = ariaDescribedby;
    $[9] = ariaLabelledby;
    $[10] = id;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== animateState || $[13] !== t3) {
    t4 = {
      rootProperties: t3,
      animateState
    };
    $[12] = animateState;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
function _temp(event) {
  event.stopPropagation();
}